export const LinkContainer = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode;
}) => {
  return <div className="flex items-center justify-between">{children}</div>;
};
